<template>
    <section v-if="hasPermissions(['Associate-Role Read','Associate-Role Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Roles. Click "Add Role" to create a new role.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="roles.length && hasPermissions(['Associate-Role Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Associate-Role Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Associate-Role Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="roles.length && hasPermissions(['Associate-Role Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="roles"
                                :search="search"
                                :checkable="true"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Role'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Role Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <DeletionValidationModal 
        :validation_table_headers="deletion_validation_table_headers"
        :validate_data="validate_data"
        :breadcrumb="breadcrumb"
        message="The following roles were not deleted because there are associates linked to them. Please note that these associates may also be linked to items in the recycle bin."
        />

        <WaitingModal/>

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import DeletionValidationModal          from    '@/components/DeletionValidationModal'
import 'vuetify/dist/vuetify.min.css'
const number_format = new Intl.NumberFormat("en-US");
import DinamicTable     from    '@/components/DinamicTable'
import HelperModal          from    '@/components/HelperModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name:   'Roles',

    components:{
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UnauthorizedComponent,
        DeletionValidationModal,
        HelperModal
    },

    data(){
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Roles',
            rest_api:           `roles`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            deletion_validation_table_headers: Resources.deletion_validation_table_headers,
            add_btn:            'Add Role',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            roles:          [],
            array_options:      {},
            select_ids:         [],
            helps:              Resources.helps,
            validate_data: []
        }
    },

    methods:{

        format_number(value)
        {
            return value !== undefined ? number_format.format(value): '';
        },
        
        unshift_object(new_object)
        {
            this.roles.unshift(new_object)
            console.log(this.roles)
        },

        splice_object(splicing_object)
        {
            this.roles.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            this.array_options = {
                roles_id: JSON.parse(JSON.stringify(this.roles))
            }
            
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.roles[index]
            
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.roles[index]

            let roles = JSON.parse(JSON.stringify(this.roles))
            let found_index = roles.findIndex(role => role.id == this.single_object.id)
            
            if(found_index > -1)
            {
                roles.splice(found_index, 1)
            }

            this.array_options = {
                roles_id: roles
            }
            window.$('#static-update').modal('show')
        },
      
        fill_data(data)
        {
            this.roles = data.roles
        },

        trashing(index)
        {
            this.roles.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.roles.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            this.loader(true)

            let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

            this.loader()

            if(response)
            {
                const validation_data = response.data.validated_roles

                if(validation_data.length)
                {
                    window.$('#deletion-validations').modal('show')
                    this.validate_data = validation_data
                }

                window.$('#static-deletion-massive').modal('hide')

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.roles.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.roles.splice(index, 1)
                    }
                })

                this.select_ids = []
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Associate-Role Read','Associate-Role Write']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.roles.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>